import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import { hasRole, type Role } from '@conversia/shared-types';

/**
 * Guarda de rutas: si no hay sesión, redirige a /login conservando el destino.
 * Si hay token pero aún no se cargó el usuario, dispara `loadMe`.
 * `requireRole` exige un rol mínimo (redirige a / si no alcanza).
 */
export function ProtectedRoute({
  children,
  requireRole,
}: {
  children: React.ReactNode;
  requireRole?: Role;
}) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const loadMe = useAuthStore((s) => s.loadMe);
  const location = useLocation();

  useEffect(() => {
    if (accessToken && !user) void loadMe();
  }, [accessToken, user, loadMe]);

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requireRole && user && !hasRole(user.role, requireRole)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
